function fileExtension(title) {
    return title.split('.').pop();
}
export default fileExtension;